/**
 * Component: Page header
 * Requires flickity for the slideshow
 */


var ed = ed || {};

ed.pageHeader = new function(){
    var pageHeader = $('#page-header');

    /**
     * Init function
     */
    this.init = function() {
        slideshow();
    };


    /**
     * Video
     * We expose this function as we need to fire it on window load rather than document ready
     */
    this.video = function() {
        if (!pageHeader.hasClass('page-header--video') || $('.page-header-video-media__iframe', pageHeaderVideo).length !== 0) {
            return;
        }

        var pageHeaderVideo = $('.page-header-video-media', pageHeader);
            videoId = pageHeaderVideo.data('video'),
            videoIframeHtml = $('<iframe class="page-header-video-media__iframe" width="1200" height="674" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('src', 'https://player.vimeo.com/video/'+ videoId +'?background=1');

        // Append the video
        pageHeaderVideo.html(videoIframeHtml);
    };

    /**
     * Video mobile fix
     * We won't load the video on small screens, and remove it, if it did load (tilting a tablet for instance)
     */
    this.videoMobile = function() {
        if (!pageHeader.hasClass('page-header--video')) {
            return;
        }

        var pageHeaderVideo = $('.page-header-video-media', pageHeader);

        if (window.innerWidth < 992) {
            if ($('.page-header-video-media__iframe', pageHeaderVideo).length > 0) {
                $('.page-header-video-media__iframe', pageHeaderVideo).remove();
            }
        }
        else {
            // desktop view
            ed.pageHeader.video();
        }

    };

    /**
     * Slideshow
     */
    function slideshow() {
        if (!pageHeader.hasClass('page-header--slideshow')) {
            return;
        }

        var pageHeaderSlideshow = $('.page-header-slideshow', pageHeader);

        // Remove display none class
        pageHeaderSlideshow.removeClass('js-hidden');

        // Trigger redraw for transition
        pageHeaderSlideshow.first().offsetHeight;

        // Init flickity
        pageHeaderSlideshow.flickity({
            cellSelector: '.page-header-slideshow-slide',
            accessibility: false,
            pageDots: true,
            contain: true,
            cellAlign: 'left',
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 70, y2: 40,
                x3: 30
            }
        });

        // Dispatch a resize event to make sure sliders aren't cut in half cause of weird load timings
        window.dispatchEvent(new Event('resize'));
    }
};
